import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

import { EditorModule } from '@tinymce/tinymce-angular';
import { FormlyModule } from '@ngx-formly/core';
import { MaterialModule } from '@app/material/material.module';

import { ButtonModule } from '@shared/components/button/button.module';
import { FormFieldCrudControlsModule } from '@shared/components/formly-custom-templates/form-field-crud-controls/form-field-crud-controls.module';

import { OutputDialogComponent } from './output-dialog.component';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  imports: [
    ButtonModule,
    CommonModule,
    EditorModule,
    FormFieldCrudControlsModule,
    FormlyModule,
    FormsModule,
    HttpClientModule,
    MaterialModule,
    ReactiveFormsModule
  ],
  declarations: [OutputDialogComponent],
  entryComponents: [OutputDialogComponent],
  exports: [OutputDialogComponent]
})
export class OutputDialogModule {}
